export default "__VITE_ASSET__f51c1b8c__"